
import { LogEntry, LogLevel } from './types';

/**
 * Logger class for outputting to console
 */
export class ConsoleLogger {
  /**
   * Log to browser console for immediate feedback
   */
  public logToConsole(logEntry: LogEntry): void {
    const { level, message, details, source } = logEntry;
    
    const formattedMessage = `[${level.toUpperCase()}]${source ? ` [${source}]` : ''}: ${message}`;
    
    switch (level) {
      case 'debug':
        console.debug(formattedMessage, details || '');
        break;
      case 'info':
        console.info(formattedMessage, details || '');
        break;
      case 'warn':
        console.warn(formattedMessage, details || '');
        break;
      case 'error':
      case 'fatal':
        console.error(formattedMessage, details || '');
        break;
      default:
        console.log(formattedMessage, details || '');
        break;
    }
  }
}
